import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession';
import { connect } from 'react-redux';
import { actions as ModalActions } from '@wix/da-shared-react/pkg/Modals';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { AppState } from '../../../../types/store';
import { getInstallableModulesInfo } from '../../../selectors/layout';
import { Props } from './AddWidget';

export type ConnectedKeys =
  | 'hasCoreMembership'
  | 'installableModulesInfo'
  | 'pushBecomeCorePopup';

export type ContainerProps = Without<Props, ConnectedKeys>;

const mapStateToProps = (
  state: AppState,
  props: ContainerProps
): Partial<Props> => ({
  hasCoreMembership: getCurrentUserHasCore(state),
  installableModulesInfo: props.installableModules.map(
    ({ moduleName, zone }) => {
      const m = getInstallableModulesInfo(state, props.section, zone) || [];
      return m.find(module => module.moduleName === moduleName);
    }
  ),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  pushBecomeCorePopup: () =>
    dispatch(
      ModalActions.pushModal(ModalType.BECOME_CORE, { wrapInPopup: false })
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
